export default "__VITE_ASSET__DwDAdFFu__"